import { useEffect, useMemo, useRef } from "react"
import "spoilerjs/spoiler-span"
import { telegramMarkdownToHtml } from "@/shared/lib/telegram-markdown-html"

interface TelegramMarkdownProps {
	children: string
	className?: string
}

export function TelegramMarkdown({ children, className = "" }: TelegramMarkdownProps) {
	const containerRef = useRef<HTMLSpanElement>(null)
	const html = useMemo(() => telegramMarkdownToHtml(children), [children])

	useEffect(() => {
		const container = containerRef.current
		if (!container) return

		const openLink = (event: MouseEvent) => {
			const link = (event.target as HTMLElement).closest("a")
			if (!link) return
			event.preventDefault()
			const href = link.getAttribute("href")
			if (href) window.open(href, "_blank", "noopener,noreferrer")
		}

		container.addEventListener("click", openLink)
		return () => container.removeEventListener("click", openLink)
	}, [])

	return (
		<span
			ref={containerRef}
			className={`inline [&_strong]:font-bold [&_em]:italic [&_del]:line-through [&_code]:bg-muted [&_code]:px-1 [&_code]:py-0.5 [&_code]:rounded [&_code]:text-sm [&_code]:font-mono [&_pre]:block [&_pre]:my-2 [&_pre]:p-3 [&_pre]:bg-muted [&_pre]:rounded [&_pre]:overflow-x-auto [&_pre_code]:bg-transparent [&_pre_code]:p-0 [&_a]:text-primary [&_a]:underline [&_a:hover]:no-underline [&_a]:cursor-pointer [&_blockquote]:border-l-4 [&_blockquote]:border-muted-foreground/30 [&_blockquote]:pl-3 [&_blockquote]:my-1 [&_blockquote]:text-muted-foreground ${className}`}
			dangerouslySetInnerHTML={{ __html: html }}
		/>
	)
}
